import React, { useEffect, useState } from 'react'
import { userInfo } from '../../../../redux/Selectors/selectors'
import { useSelector } from 'react-redux'


function Participation({ userDetails, textLength, debateId, mediaLength, isUserTyping }) {
    const [activeDebaters, setActiveDebaters] = useState([])

    const [socket, setSocket] = useState(null)
    const currentLogggedInUser = useSelector(userInfo)


    function removeFromActive() {
        setActiveDebaters(prev => {
            const exists = prev.filter(item =>
                item.user_details.username !== userDetails.name
            );
            return exists
        })

    }



    useEffect(() => {
        const unFilteredURL = `wss://${process.env.REACT_APP_SERVER_URL}/ws/debatechats/${debateId}/`;
        let wsUrl = unFilteredURL.replace("https://", "")

        if (process.env.REACT_APP_ENV === "development") {
            wsUrl = `ws://localhost:8000/ws/debatechats/${debateId}/`;
        }

        const ws = new WebSocket(wsUrl);

        ws.onopen = () => {
            console.log('WebSocket Connected');
        };

        ws.onmessage = (e) => {
            try {
                const data = JSON.parse(e.data);

                setActiveDebaters(prev => {
                    // If user is not typing, remove them from the array
                    if (!data.is_typing) {
                        return prev.filter(item =>
                            item.user_details.username !== data.user_details.username
                        );
                    }

                    // If user is typing, check if they already exist
                    const exists = prev.find(item =>
                        item.user_details.username === data.user_details.username
                    );

                    // Only add if they don't exist and are typing
                    if (!exists && data.is_typing) {
                        return [...prev, data];
                    }
                    return prev;
                });

            } catch (err) {
                console.error('Error parsing message:', err);
            }
        };

        ws.onclose = (e) => {
            console.log('Participation WebSocket Closed', e);
        };

        ws.onerror = (e) => {
            console.error('Participation WebSocket Error', e);
        };

        setSocket(ws)

        // Cleanup function
        return () => {
            if (ws.readyState === WebSocket.OPEN) {
                ws.close();
            }
        };
    }, [debateId]);


    useEffect(() => {


        if (socket && (textLength >= 3 || mediaLength >= 1) && socket.readyState === WebSocket.OPEN) {
            socket.send(JSON.stringify({
                "typer": {
                    "user_details": {
                        "username": userDetails.name,
                        "dp": userDetails.profileImage
                    },
                    "is_typing": true
                }
            }))

        } else if (socket && (textLength < 3 || mediaLength === 0 || isUserTyping === "No")) {
            socket.send(JSON.stringify({
                "typer": {
                    "user_details": {
                        "username": userDetails.name,
                        "dp": userDetails.profileImage
                    },
                    "is_typing": false
                }
            })
            )
            removeFromActive()
        }


        // eslint-disable-next-line
    }, [textLength, mediaLength, debateId])





    return (
        <div>
            {activeDebaters.length > 0 && (
                <div className='flex'>
                    {activeDebaters?.slice(0, 4)?.map((item, idx) => {
                        if(item?.user_details?.username !==  currentLogggedInUser?.name){

                        const showOnlyAtLastIndex = idx === (activeDebaters.length - 1)

                        return (
                                <div className='flex' key={idx}>
                        <div className='h-6 w-6 mx-0.5'>
                            <img src={item.user_details.dp} alt='' className='h-full w-full rounded-full' />
                        </div>

                        {showOnlyAtLastIndex &&
                            <div className='flex bg-white p-0.5 mx-2 rounded-md'>
                        {[0, 1, 2].map(item =>
                            <div
                                key={item}
                                className={`h-2 w-2 mx-1 my-auto rounded-full bg-green-600 animate-bounce`}
                                style={{
                                    animationDelay: `${item * 0.2}s`,
                                    animationDuration: '1s'
                                }}
                            />
                        )}
                        </div>
                        }

                    </div>
                        )
                        }
                        return null
                    }

                    )}



                </div>
            )}
        </div>
    )
}

export default Participation
